export default __webpack_public_path__ + "static/media/newcharge.aafb861b.ico";